import { jsx as o, jsxs as c, Fragment as h } from "react/jsx-runtime";
import { Accordion as m, AccordionItem as d, AccordionButton as p, Box as s, AccordionPanel as A } from "@chakra-ui/react";
import { ChevronUpIcon as g, ChevronDownIcon as f } from "../../icons/componentIcons.mjs";
const j = ({
  data: i,
  allowMultiple: e = !0,
  defaultIndex: r = [0],
  ...t
}) => (typeof r == "number" && (r = [r]), i.length > 0 ? /* @__PURE__ */ o(m, { allowMultiple: e, defaultIndex: r, ...t, children: i.map((n) => /* @__PURE__ */ o(d, { children: ({ isExpanded: l }) => /* @__PURE__ */ c(h, { children: [
  /* @__PURE__ */ o("h4", { children: /* @__PURE__ */ c(p, { children: [
    /* @__PURE__ */ o(s, { flex: "1", textAlign: "left", children: n.title }),
    l ? /* @__PURE__ */ o(g, { size: "md", variant: "light" }) : /* @__PURE__ */ o(f, { size: "md", variant: "light" })
  ] }) }),
  /* @__PURE__ */ o(A, { children: n.content })
] }) }, n.title)) }) : null);
export {
  j as Accordion
};
